<template>
  <div class="reason-list">
    <div class="reason-list__list">
      <div
        v-for="reason in filteredList"
        :key="reason.id"
        @click="selectReason(reason)"
        class="reason-list__reason-item"
        :class="{
          'reason-list__reason-item--selected': isReasonSelected(reason),
        }"
      >
        {{ reason.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "RecountTreesDamagePickerReasonList",

  props: {
    selectedReason: Object,
    searchValue: String,
  },

  computed: {
    filteredList() {
      return this.reasonList.filter((item) => {
        return item.name.toLowerCase().includes(this.searchValue.toLowerCase());
      });
    },
    ...mapState("recount", {
      reasonList: (state) => state.trees.damageReasonList,
    }),
  },

  methods: {
    isReasonSelected(reason) {
      if (!this.selectedReason) {
        return false;
      }

      if (reason.id === this.selectedReason.id) {
        return true;
      }
    },

    selectReason(reason) {
      if (reason?.id === this.selectedReason?.id) {
        reason = null;
      }
      this.$emit("select-reason", reason);
    },
  },
};
</script>

<style scoped>
.reason-list {
  padding: 0 0.5rem;
  /* display: flex; */
  /* flex-direction: column; */
}

.reason-list__search {
  /* margin-bottom: 1rem; */
}

/* .reason-list__list {
  flex: 1;
  overflow: auto;
} */

.reason-list__reason-item {
  margin-bottom: 0.5rem;
}

.reason-list__reason-item--selected {
  background-color: lightblue;
}
</style>
